/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import PropTypes from "prop-types";
import "./radioOption.scss";
import Icon from "../Icon";

const RadioOption = ({
  id,
  key,
  name,
  value,
  disabled,
  selectedValue,
  className,
  children,
  onChange,
  isError,
  errorMessage,
  customIcon,
  customIconColor,
  isHidden,
  title,
}) => {
  const onRadioChange = (event) => {
    onChange(event.currentTarget.value);
  };

  return (
    <div>
      <div className="ls-container">
        <input
          type="radio"
          id={id}
          key={key}
          name={name}
          value={value}
          onChange={onRadioChange}
          disabled={disabled}
          checked={selectedValue === value}
        />
        <label className={className} htmlFor={id}>
          {children}
        </label>
        <span>
          <Icon
            fileName={customIcon ? customIcon : "single-selected-24"}
            focusable="false"
            className="icon-24"
            isHidden={isHidden}
            title={title}
            color={customIconColor ? customIconColor : "#047A9C"}
          />
        </span>
      </div>
      {isError && (
        <div className="ls-error-message">
          <span>
            <Icon fileName="warning-16" focusable="false" isHidden={true} />
            <label>{errorMessage}</label>
          </span>
        </div>
      )}
    </div>
  );
};

RadioOption.propTypes = {
  id: PropTypes.string.isRequired,
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  isError: PropTypes.bool,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  onChange: PropTypes.func.isRequired,
  customIcon: PropTypes.string,
  customIconColor: PropTypes.string,
  isHidden: PropTypes.bool,
  title: PropTypes.string,
};

RadioOption.defaultProps = {
  className: "",
  isHidden: false,
};

export default RadioOption;
